import { fetch } from '@/services/api/client'

/**
 * Tracks the given route using a tracking pixel.
 * @param route
 */
export const track = async (route: string) => {
  // TODO introduce web-proxy path for tracking pixel service
  const url = `https://api3.wetter.de/s/web.png?routeString=${route}`
  await fetch(url, { mode: 'no-cors' }).catch((error) => {
    console.error(`[TrackingPixel] An error occurred while tracking page`, {
      error: error,
    })
  })
}
